<template>
  <div class="container-fluid contact-us-bg">
    <div class="container contact-us-section">
      <div class="row">
        <div class="col-12 py-0 featured-text text-center">
          <div class="button-holder my-3">
            <router-link class="btn button-primary" :to="path">{{ buttonText }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'action-panel',
  props: {
    buttonText: {
      type: String,
      default: 'Home',
      required: false
    },
    path: {
      type: String,
      default: '/',
      required: false
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/ActionPanel.vue